import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function DeepDive() {
  return <>
      <Section className="bg-[#fcfbf7]" data-id="element-1">
        <div className="max-w-3xl mx-auto" data-id="element-2">
          <h2 className="text-3xl md:text-4xl font-serif text-[#0f4c3a] text-center mb-12" data-id="element-3">
            Cómo se ve la vida cuando estás atrapada en el chip
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-4">
            <div className="space-y-4" data-id="element-5">
              {['La quincena se evapora.', "Te dices 'luego lo arreglo'.", 'Evitas mirar la cuenta porque te da ansiedad.', 'Compensas estrés con compras pequeñas.'].map((item, i) => <div key={i} className="flex items-center gap-3 text-slate-600" data-id="element-6">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-7" />
                  <span data-id="element-8">{item}</span>
                </div>)}
            </div>
            <div className="space-y-4" data-id="element-9">
              {['Te comparas en silencio y te duele.', 'Y pensar en una emergencia te da terror.', 'No es solo plata.', 'Es seguridad. Es calma. Es dignidad.'].map((item, i) => <div key={i} className="flex items-center gap-3 text-slate-600" data-id="element-10">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0" data-id="element-11" />
                  <span data-id="element-12">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="text-center bg-white p-8 rounded-xl shadow-sm border border-[#0f4c3a]/10" data-id="element-13">
            <p className="text-xl text-[#0f4c3a] mb-4" data-id="element-14">Y aquí viene el giro:</p>
            <p className="text-2xl font-serif text-[#d4af37]" data-id="element-15">
              No estás desordenada… estás programada.
            </p>
            <p className="text-slate-600 mt-4" data-id="element-16">
              Y si es programación… se puede reprogramar.
            </p>
          </div>
        </div>
      </Section>

      {/* Metaphor 3: River */}
      <Section className="bg-white" data-id="element-17">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-18">
          <div className="flex-1" data-id="element-19">
            <h3 className="text-3xl font-serif text-[#0f4c3a] mb-6" data-id="element-20">
              Metáfora 3: el río bloqueado
            </h3>
            <p className="text-lg text-slate-700 mb-6" data-id="element-21">
              La abundancia es un río. Tus creencias son diques invisibles.
            </p>
            <p className="text-slate-600 mb-6" data-id="element-22">
              No es que no haya flujo… es que tu sistema aprendió a bloquearlo
              para "estar a salvo".
            </p>
            <p className="font-medium text-[#0f4c3a]" data-id="element-23">
              ABUNDANCIA & DINERO existe para romper esos diques con conciencia
              y con estructura.
            </p>
          </div>
          <div className="flex-1 relative h-64 w-full bg-[#f0f7f4] rounded-2xl overflow-hidden flex items-center justify-center" data-id="element-24">
            {/* Abstract River Visual */}
            <div className="absolute inset-0" data-id="element-25">
              <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full opacity-20" data-id="element-26">
                <path d="M0,50 C20,60 40,40 60,50 C80,60 100,40 120,50" stroke="#0f4c3a" strokeWidth="2" fill="none" data-id="element-27" />
                <path d="M0,60 C20,70 40,50 60,60 C80,70 100,50 120,60" stroke="#0f4c3a" strokeWidth="2" fill="none" data-id="element-28" />
                <path d="M0,40 C20,50 40,30 60,40 C80,50 100,30 120,40" stroke="#0f4c3a" strokeWidth="2" fill="none" data-id="element-29" />
              </svg>
            </div>
            <div className="relative z-10 bg-white p-6 rounded-lg shadow-md max-w-xs text-center" data-id="element-30">
              <span className="text-[#0f4c3a] font-serif font-bold" data-id="element-31">
                Fluidez = Conciencia + Estructura
              </span>
            </div>
          </div>
        </div>
      </Section>

      <Section dark className="text-center" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-serif text-[#d4af37] mb-12" data-id="element-33">
          Lo que vas a experimentar cuando lo haces bien
        </h2>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto text-left" data-id="element-34">
          {["Dejas de vivir en 'modo quincena'.", 'Empiezas a mirar tu dinero con calma.', 'Tienes un método que se sostiene incluso con cansancio.', 'Dejas de sabotearte con micro-decisiones.', 'Tu energía sale de la urgencia → y empiezas a ver oportunidades.', 'Se instala una nueva identidad'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 p-4 rounded-lg bg-white/5 border border-white/10" data-id="element-35">
              <div className="bg-[#d4af37] rounded-full p-1 mt-1 flex-shrink-0" data-id="element-36">
                <Check className="w-3 h-3 text-[#0f4c3a]" data-id="element-37" />
              </div>
              <span className="text-white" data-id="element-38">{item}</span>
            </motion.div>)}
        </div>

        <div className="mt-12 p-8 bg-[#d4af37]/10 rounded-xl border border-[#d4af37]/30 inline-block" data-id="element-39">
          <p className="text-2xl font-serif text-[#d4af37] italic" data-id="element-40">
            "Yo soy una mujer que retiene, administra y multiplica."
          </p>
          <p className="text-white mt-4 text-sm" data-id="element-41">
            No por magia. Por reprogramación + acciones consistentes.
          </p>
        </div>
      </Section>
    </>;
}